import React from "react";
import {DangerButton} from "../../../../components/CustomButton";
import CustomCarousel from "../carousel/CustomCarousel";
import {FocusedHorizontalListLoader} from "./FocusedHorizontalList";

export default function FocusedLoader({
                                        length = 1,
                                        isHorizontalStyle,
                                        extras, mobile, hasTitleSection = false, isBannerStyle, ar,
                                        hf,
                                      }) {
  return (
    <>
       {        
        isBannerStyle ? <CustomCarousel bannerList={{loading: true, data: {page_info: {extras}}}} mobile={mobile}/> :
          isHorizontalStyle ? <FocusedHorizontalListLoader arrow={extras?.arrow} length={length} aspectRatio={ar} heightFactor={hf} mobile={mobile} hasTitles={hasTitleSection}/> :
          Array.from({length: length},
            (v, k) =>
              <div className="animate-pulse shadow-md" key={`focused-item-loader-${k}`}>
                <div
                  className="bg-loader w-full" style={{aspectRatio: `${ar}`}}>

                </div>
                {hasTitleSection && <div className="text-center bg-white py-2 mx-2">
                  <div className="h-3 bg-loader mb-1">&nbsp;</div>
                  <div className="h-3 bg-loader">&nbsp;</div>
                </div>
                }
              </div>
          )
      }
    </>

  );
}

export function FocusedError({errorMsg, retry}) {
  return (
    <div className="w-full flex justify-evenly flex-col bg-red-100 image-aspect-ratio items-center">
      <div
        className="text-center text-error-500 leading-none text-sm font-bold px-2 whitespace-pre-wrap">
        {errorMsg}
      </div>
      <div className="text-center">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>

    </div>
  );
}

export function FocusedNoData({msg}) {
  return (
    <div className="w-full flex items-center justify-center bg-secondary-100 image-aspect-ratio text-rand-400">
      {msg ? msg : 'No Data'}
    </div>
  );
}